module.exports = __webpack_public_path__ + "static/media/rampageslayer2000.c07d5e69.jpeg";